import { Marker, Popup } from "react-leaflet"
import { Position } from "./types"

type Props = {
  content: string
  position: Position
}

export const MapMarkerWithPopup = ({ content, position }: Props) => (
  <Marker position={[position[0], position[1]]}>
    <Popup closeButton={false}>{content}</Popup>
  </Marker>
)
